import { render, staticRenderFns } from "./EducationalScheduleTimeInfo.vue?vue&type=template&id=59486bbf&"
import script from "./EducationalScheduleTimeInfo.vue?vue&type=script&lang=js&"
export * from "./EducationalScheduleTimeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports